import { AutoAwesome } from '@mui/icons-material';
import { Badge, IconButton } from '@mui/material';
import { useFieldAutofillStatus } from 'api/datamaid';
import { DataMaidEntityMenu } from 'components/entityMenu/datamaidMenu';
import React, { useMemo, useState } from 'react';
import { FinsightEntity } from 'shared';

type DataMaidEntityButtonProps = {
  entity: FinsightEntity;
};

export default function DataMaidEntityButton(props: DataMaidEntityButtonProps) {
  const { entity } = props;
  const autofillStatus = useFieldAutofillStatus(entity.id);

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const notifcationCount = useMemo(() => {
    let notifcations: number = 0;

    if (autofillStatus.data?.length) {
      if (autofillStatus.data[0].status === 'review') {
        notifcations++;
      }
    }

    return notifcations;
  }, [autofillStatus.data]);

  const showLoader = useMemo(() => {
    if (autofillStatus.data?.length) {
      if (
        autofillStatus.data[0].status === 'pending' ||
        autofillStatus.data[0].status === 'processing'
      ) {
        return true;
      }
    }

    return false;
  }, [autofillStatus.data]);

  return (
    <>
      <Badge badgeContent={notifcationCount} color="error" overlap="circular">
        {showLoader ? (
          <div
            style={{
              position: 'relative',
              borderRadius: '4px',
              overflow: 'hidden',
              padding: '2px',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: '200%',
                height: '200%',
                background:
                  'conic-gradient(from 0deg, transparent 0deg, transparent 90deg, rgba(236, 72, 153, 1) 135deg, rgba(168, 85, 247, 1) 180deg, transparent 225deg, transparent 270deg, rgba(236, 72, 153, 1) 315deg, rgba(168, 85, 247, 1) 360deg)',
                animation: 'spin 2s linear infinite',
                transform: 'translate(-50%, -50%)',
              }}
            />
            <IconButton
              onClick={(e) => setAnchorEl(e.currentTarget)}
              size="small"
              sx={{
                position: 'relative',
                color: 'white',
                background:
                  'linear-gradient(148deg, rgba(8, 180, 128, 1), rgba(17, 184, 235, 1))',

                '@keyframes spin': {
                  '0%': {
                    transform: 'translate(-50%, -50%) rotate(0deg)',
                  },
                  '100%': {
                    transform: 'translate(-50%, -50%) rotate(360deg)',
                  },
                },
              }}
            >
              <AutoAwesome />
            </IconButton>
          </div>
        ) : (
          <IconButton
            onClick={(e) => setAnchorEl(e.currentTarget)}
            size="small"
            sx={{
              color: 'white',
              background:
                'linear-gradient(148deg, rgba(8, 180, 128, 1), rgba(17, 184, 235, 1))',
            }}
          >
            <AutoAwesome />
          </IconButton>
        )}
      </Badge>
      <DataMaidEntityMenu
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        entities={[entity]}
      />
    </>
  );
}
